// Hosted-agents preview region list. Source (verified 2026-05-25):
// https://learn.microsoft.com/azure/foundry/agents/concepts/hosted-agents#limits,-pricing,-and-availability-preview
// The list moves during preview — update this constant when MS adds regions.
export const HOSTED_AGENT_REGIONS = [
  "eastus2",
  "northcentralus",
  "swedencentral",
  "canadacentral",
  "southeastasia",
  "polandcentral",
  "southafricanorth",
  "koreacentral",
  "southindia",
  "brazilsouth",
  "westus",
  "westus3",
  "norwayeast",
  "japaneast",
  "francecentral",
  "switzerlandnorth",
  "spaincentral",
  "australiaeast",
] as const;

/** Normalize a region label ("East US 2", "EastUS2") to the canonical key ("eastus2"). */
function normalizeRegion(region: string): string {
  return region.toLowerCase().replace(/\s+/g, "");
}

export function isHostedRegionSupported(region: string): boolean {
  const n = normalizeRegion(region);
  return (HOSTED_AGENT_REGIONS as readonly string[]).includes(n);
}
